import React, { useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from "react-intl";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import {ConfirmationModal} from "../../../../../layout/Modal/ConfirmationModal";
import {deleteUser as deleteAdminUserApi} from "../../../../../../api/admin/users";
import {
  NOTIFICATION_ADMIN_ACTIONS
} from "../../../../../../config/notifications";
import { ACL } from '../../../../../../config/constants/UogACL/ACL';
import { store } from '../../../../../../store/store';
import { hideNotification } from '../../../../../../store/actions/notification';

const DeleteUser = ({ user, index, actionCallback, showIcon }) => {
  const [ showDeleteModal, setShowDeleteModal ] = useState( false );

  if (!ACL.ADMIN.USERS.DELETE.hasAccess()) {
    return null;
  }

  const deleteAdminUser = () => {
    deleteAdminUserApi( {
      userId: user.id,
      notificationId: NOTIFICATION_ADMIN_ACTIONS
    } ).then( (response) => {
      setShowDeleteModal( false );
      if (response && response.status === 204) {
        actionCallback(true);
      }
    } );
  };

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`delete-user-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowDeleteModal( true )
            }}
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.delete_user"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`delete-user-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.delete_user"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`delete-user-icon-` + index}
            onClick={() => setShowDeleteModal( true )}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faTrash}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`delete-user-icon-${index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.delete_user"/>
          </UncontrolledTooltip>
        </Fragment>
      }

        <ConfirmationModal
        showModal={showDeleteModal}
        closeModal={() => setShowDeleteModal( false )}
        confirmationYes={deleteAdminUser}
        />
    </Fragment>
  )
}

export {
  DeleteUser
};
